export default __webpack_public_path__ + "static/media/HomeoLatest.0664ed68.webp";